import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import jwtDecode from 'jwt-decode';
import { LoginService } from 'src/app/core/services/login.service';
import { ProfileService } from '../../services/profile.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { VerifyOtpComponent } from '../verify-otp/verify-otp.component';
import { ToastService } from 'src/app/core/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { SlsService } from 'src/app/core/services/sls.service';
@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit {
  token: any;
  butDisabled: boolean = true;
  signUpDetailsForm: FormGroup;
  subscriberDetailForm: FormGroup;
  contactInformationForm: FormGroup;
  professionalDetailsForm: FormGroup;
  otherDetailsForm: FormGroup
  statusMsg: any;
  userPhoto: any;
  phoneBlock: boolean = true;
  bankOneBlock: boolean = true;
  conBlock: boolean = true;
  emailrequire: boolean = false;
  // bankTwoBlock:boolean = true;
  // bankThreeBlock:boolean = true;
  // bankFourBlock:boolean = true;
  updatePhone = {
    phone: null
  };
  profImage = {
    profile_image: null
  }
  suppImage = {
    logo: null
  }
  pracImage = {
    logo: null
  }
  /* --------------------------------- FIELDS -------------------------------- */
  userForm: FormGroup = this.fb.group({
    // profileImage: [null],
    fName: [null, [Validators.required]],
    lName: [null, [Validators.required]],
    email: [null, [Validators.required]],
    phone: [null, [Validators.required]],
    password: [null, [Validators.required]],
    confirmPassword: [null, [Validators.required]],
    altEmail: [null, [Validators.required]],
    altPhone: [null, [Validators.required]],
    addLine1: [null, [Validators.required]],
    addLine2: [null, [Validators.required]],
    landmark: [null, [Validators.required]],
    city: [null, [Validators.required]],
    state: [null, [Validators.required]],
    country: [null, [Validators.required]],
    zipCode: [null, [Validators.required]],
    drivingLicense: [null, [Validators.required]],
    regNumber: [null, [Validators.required]],
    professionType: [null, [Validators.required]],
    bankName: [null, [Validators.required]],
    accountName: [null, [Validators.required]],
    accountNumber: [null, [Validators.required]],
    bsb: [null, [Validators.required]],
    // phone: [null, [ Validators.pattern(/^(\+91)[1-9]{1}[0-9]{9}/)]],
    // isProfileCompleted: [true]
  });
  mobileForm: FormGroup = this.fb.group({
    mobile: ['+91', [Validators.required, Validators.pattern(/^(\+91)[1-9]{1}[0-9]{9}/)]]
  });
  verifyForm: FormGroup = this.fb.group({
    code: [null, [Validators.required]]
  });
  oldProfile: any;
  userDetails: any;
  userDisplay: any = [{
    second_hand: false
  }];
  phoneObj = {
    email: null,
    type: null
  }
  contactProf = {
    alt_email: null,
    alt_phone: null
  }
  contactSupp = {
    alt_phone: null,
    alt_email: null,
    business_email: null,
    business_phone: null,
    secondary_name: null,
    secondary_email: null,
    secondary_phone: null

  }
  bankDetails = {
    bank_details: {
      bank_name: null,
      account_number: null,
      account_holder_name: null,
      bsb: null
    },
    second_hand: null
  }
  // confirmationResult: firebase.auth.ConfirmationResult;
  otherBlock: boolean = true
  showMobileLinkSection: any;
  userProfileData: any;
  userData: any;
  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private loginService: LoginService,
    private _fb: FormBuilder,
    private _dialog: MatDialog,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private mediaService: MediaService,
    private sls: SlsService
  ) { }
  ngOnInit(): void {
    this.token = this.loginService.getLoginData();
    console.log("Profile Details Token", this.token);
    this.subscriberDetailForm = this._fb.group({
      salutation: [null, [Validators.required]],
      first_name: [null, [Validators.required]],
      last_name: [null, [Validators.required]],
      middle_name: [null],
      dob: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      profile_image: [null],
      businessLogo: [null],
      businessName: [null, [Validators.required]],
      ABN_ACN_number: [null, [Validators.required]],
    });
    this.signUpDetailsForm = this._fb.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required]],
      phone: [null, [Validators.required]]
      //type: [null, [Validators.required]]
    });
    this.phone.disable();
    this.contactInformationForm = this._fb.group({
      fName: [null, [Validators.required]],
      lName: [null, [Validators.required]],
      mName: [null, [Validators.required]],
      businessPhoneNumber: [null],
      //emailtwo: [null, [Validators.required]],
      altEmail: [null],
      //phoneNo: [null, [Validators.required]],
      altPhoneNo: [null],
      address: [null, [Validators.required]],
      address_line_one: [null, [Validators.required]],
      address_line_two: [null],
      land_mark: [null, [Validators.required]],
      city: [null, [Validators.required]],
      state: [null, [Validators.required]],
      country: [null, [Validators.required]],
      zipcode: [null, [Validators.required]],
      businessEmail: [null, [Validators.required]],
      faxNumber: [null, [Validators.required]],
      emailTwo: [null, [Validators.required]],
      phoneNoTwo: [null, [Validators.required]],
      contactName: [null, [Validators.required]],
    });
    this.businessPhoneNumber.disable();
    this.altEmail.disable();
    this.altPhoneNo.disable();
    this.businessEmail.disable();
    this.professionalDetailsForm = this._fb.group({
      professionType: [null, [Validators.required]],
      pro_details_aphra_registration_number: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      drivingLicense: [null, [Validators.required]],
      tga: [null, [Validators.required]],
      // dentalCertificate: [null, [Validators.required]],
      // hourly_charge_in_aud: [null, [Validators.required]],
      // hourly_charge_in_usd: [null, [Validators.required]],
      // areas_of_interest: [null, [Validators.required]],
      // registration_certificate_attachment: [null, , [Validators.required]],
      // doctorLicense: [null, [Validators.required]],
      // resume_attachment: [''],
      // bank_name: [null, [Validators.required]],
      // branch_name: [null, [Validators.required]],
      // account_holder_name: [null, [Validators.required]],
      // account_number: [null, [Validators.required]],
      // bsb: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
    this.otherDetailsForm = this._fb.group({
      sellSecondHandSupplies: [null],
      sellProducts: [null],
      bank_name: [null, [Validators.required]],
      //branch_name: [null, [Validators.required]],
      account_holder_name: [null, [Validators.required]],
      account_number: [null, [Validators.required]],
      bsb: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
    this.bank_name.disable();
    this.account_holder_name.disable();
    this.account_number.disable();
    this.bsb.disable();
    this.token = this.sls.get('loginData');
    console.log("Profile details token", this.token);
    if (this.token.type == "SUPPLIER") {
      console.log("I came here");
      this.profileService.getSupplierDisplay(this.token.id).subscribe(data => {
        console.log("Profile Details 1212--->", data)
        this.userDisplay = data
        console.log('userDisplay', this.userDisplay);

        this.signUpDetailsForm.patchValue({
          email: this.userDisplay.email,
          phone: this.userDisplay.phone,
          name: this.userDisplay.name
        });
        this.subscriberDetailForm.patchValue({
          ABN_ACN_number: this.userDisplay.abn_number,
          businessName: this.userDisplay.business_name,
          // first_name: this.userDisplay.first_name,
          // last_name: this.userDisplay.last_name,
          // middle_name: this.userDisplay.middle_name,
          // dob:this.userDisplay.dob,
          // gender:this.userDisplay.gender,
          // salutation:this.userDisplay.salutation
        });
        this.contactInformationForm.patchValue({
          altEmail: this.userDisplay.alt_email,
          altPhoneNo: this.userDisplay.alt_phone,
          address_line_one: this.userDisplay?.address?.address_line_one,
          address_line_two: this.userDisplay?.address?.address_line_two,
          address: this.userDisplay?.address?.addressName,
          // address_line_two:this.userData.payload.address.address_line_two,
          state: this.userDisplay?.address?.state,
          city: this.userDisplay?.address?.city,
          country: this.userDisplay?.address?.country,
          zipcode: this.userDisplay?.address?.zipcode,
          land_mark: this.userDisplay?.address?.land_mark,
          businessEmail: this.userDisplay?.business_email,
          faxNumber: this.userDisplay?.fax_number,
          businessPhoneNumber: this.userDisplay?.business_phone,
          contactName: this.userDisplay?.secondary_contact?.name,
          emailTwo: this.userDisplay?.secondary_contact?.email,
          phoneNoTwo: this.userDisplay?.secondary_contact?.phone,
          fName: this.userDisplay?.first_name,
          lName: this.userDisplay?.last_name,
          mName: this.userDisplay?.middle_name
        });
        this.professionalDetailsForm.patchValue({
          professionType: this.userDisplay.profession_type,
          // pro_details_aphra_registration_number: this.userData.payload.pro_details_aphra_registration_number,
          // drivingLicense: this.userData.payload.drivingLicense,
          tga: this.userDisplay.tga_number
        });
        this.otherDetailsForm.patchValue({
          sellSecondHandSupplies: this.userDisplay.second_hand,
          sellProducts: this.userDisplay.sell_products,
          //  sellProducts:[null],
          bank_name: this.userDisplay?.bank_details?.bank_name,
          //branch_name: [null, [Validators.required]],
          account_holder_name: this.userDisplay?.bank_details?.account_holder_name,
          account_number: this.userDisplay?.bank_details?.account_number,
          bsb: this.userDisplay?.bank_details?.bsb,
        })
      })
    }

    if (this.token.type == "PRACTICE") {
      this.profileService.getPracticeDisplay(this.token.id).subscribe(data => {
        console.log(data)
        this.userDisplay = data
        this.signUpDetailsForm.patchValue({
          email: this.userDisplay.email,
          phone: this.userDisplay.phone,
          name: this.userDisplay.name
        });
        this.subscriberDetailForm.patchValue({
          ABN_ACN_number: this.userDisplay.abn_number,
          businessName: this.userDisplay.business_name,
          //   first_name: this.userDisplay.first_name,
          //   last_name: this.userDisplay.last_name,
          //   middle_name: this.userDisplay.middle_name,
          // //  dob:this.userDisplay.dob,
          //   gender:this.userDisplay.gender,
          //   salutation:this.userDisplay.salutation
        });
        this.contactInformationForm.patchValue({
          altEmail: this.userDisplay.alt_email,
          altPhoneNo: this.userDisplay.alt_phone,
          address_line_one: this.userDisplay.address.address_line_one,
          address_line_two: this.userDisplay.address.address_line_two,
          // address_line_two:this.userData.payload.address.address_line_two,
          state: this.userDisplay.address.state,
          city: this.userDisplay.address.city,
          address: this.userDisplay.address.addressName,
          country: this.userDisplay.address.country,
          zipcode: this.userDisplay.address.zipcode,
          land_mark: this.userDisplay.address.land_mark,
          businessEmail: this.userDisplay.business_email,
          faxNumber: this.userDisplay.fax_number,
          businessPhoneNumber: this.userDisplay.business_phone,
          contactName: this.userDisplay.secondary_contact.name,
          emailTwo: this.userDisplay.secondary_contact.email,
          phoneNoTwo: this.userDisplay.secondary_contact.phone,
          fName: this.userDisplay.first_name,
          lName: this.userDisplay.last_name,
          mName: this.userDisplay.middle_name
        });
        this.professionalDetailsForm.patchValue({
          professionType: this.userDisplay.profession_type,
          pro_details_aphra_registration_number: this.userDisplay.pro_details_aphra_registration_number,
          drivingLicense: this.userDisplay.driving_licence,
          tga: this.userDisplay.tga_number
        });
        this.otherDetailsForm.patchValue({
          sellSecondHandSupplies: this.userDisplay.second_hand,
          //  sellProducts:[null],
          bank_name: this.userDisplay.bank_details.bank_name,
          //branch_name: [null, [Validators.required]],
          account_holder_name: this.userDisplay.bank_details.account_holder_name,
          account_number: this.userDisplay.bank_details.account_number,
          bsb: this.userDisplay.bank_details.bsb,
        })
      })
    }
    if (this.token.type == "PROFESSIONAL") {
      this.profileService.getProfDisplay(this.token.id).subscribe(data => {
        console.log(data)
        this.userDisplay = data
        this.userDisplay = data
        console.log('userDisplay', this.userDisplay);

        this.signUpDetailsForm.patchValue({
          email: this.userDisplay.email,
          phone: this.userDisplay.phone,
          name: this.userDisplay.name
        });
        this.subscriberDetailForm.patchValue({
          //  ABN_ACN_number:this.userDisplay.abn_number,
          //  businessName:this.userDisplay.business_name,
          first_name: this.userDisplay.first_name,
          last_name: this.userDisplay.last_name,
          middle_name: this.userDisplay.middle_name,
          dob: this.userDisplay.date_of_birth,
          gender: this.userDisplay.gender,
          salutation: this.userDisplay.salutation
        });
        this.contactInformationForm.patchValue({
          altEmail: this.userDisplay.alt_email,
          altPhoneNo: this.userDisplay.alt_phone,
          address_line_one: this.userDisplay.address.address_line_one,
          address_line_two: this.userDisplay.address.address_line_two,
          // address_line_two:this.userData.payload.address.address_line_two,
          state: this.userDisplay.address.state,
          city: this.userDisplay.address.city,
          address: this.userDisplay.address.addressName,
          country: this.userDisplay.address.country,
          zipcode: this.userDisplay.address.zipcode,
          land_mark: this.userDisplay.address.land_mark,
          // businessEmail: this.userDisplay.business_email,
          //faxNumber: this.userDisplay.fax_number,
          //businessPhoneNumber:this.userDisplay.business_phone,
          //contactName:this.userDisplay.secondary_contact.name,
          //emailTwo:this.userDisplay.secondary_contact.email,
          //phoneNoTwo:this.userDisplay.secondary_contact.phone,
          fName: this.userDisplay.first_name,
          lName: this.userDisplay.last_name,
          mName: this.userDisplay.middle_name
        });
        this.professionalDetailsForm.patchValue({
          professionType: this.userDisplay.profession_type,
          pro_details_aphra_registration_number: this.userDisplay.pro_details_aphra_registration_number,
          drivingLicense: this.userDisplay.driving_licence,
          //tga:this.userDisplay.tga_number
        });
        this.otherDetailsForm.patchValue({
          sellSecondHandSupplies: this.userDisplay.second_hand,
          //  sellProducts:[null],
          bank_name: this.userDisplay.bank_details.bank_name,
          //branch_name: [null, [Validators.required]],
          account_holder_name: this.userDisplay.bank_details.account_holder_name,
          account_number: this.userDisplay.bank_details.account_number,
          bsb: this.userDisplay.bank_details.bsb,
        })
      })
    }
    //console.log(resData)
    // //this.token = jwtDecode(localStorage.getItem("accessToken"));
    // console.log(this.token)
    //  if(this.token.type == "PRACTICE"){
    //   this.profileService.getUserProfilePracice(this.token.id).subscribe(data=>{
    //     this.userProfileData = data
    //     console.log(this.userProfileData)
    //     this.userForm.patchValue({
    //       email:this.userProfileData.email,
    //       phone:this.userProfileData.phone
    //     })
    //   })
    // }
    // if(this.token.type == "PROFESSIONAL"){
    //   this.profileService.getUserProfileProfessional(this.token.id).subscribe(data=>{
    //     this.userProfileData = data
    //     console.log(this.userProfileData)
    //     this.userForm.patchValue({
    //       email:this.userProfileData.email,
    //       phone:this.userProfileData.phone,
    //       fName:this.userProfileData.first_name,
    //       lName:this.userProfileData.last_name
    //     })
    //   })
    // }
    // if(this.token.type === "SUPPLIER"){
    //   this.profileService.getUserProfileSuplier(this.token.id).subscribe(data=>{
    //     this.userProfileData = data
    //     console.log(this.userProfileData)
    //     // this.userForm.patchValue({
    //     //   email:this.userProfileData.email,
    //     //   phone:this.userProfileData.phone
    //     // })
    //   })
    // }

    /** spinner starts on init */
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 1000);
  }
  updateProfile() {
  }
  /* --------------------------------- Getters -------------------------------- */
  get phone(): AbstractControl {
    return this.signUpDetailsForm.get('phone');
  }
  get bank_name(): AbstractControl {
    return this.otherDetailsForm.get('bank_name');
  }
  get account_holder_name(): AbstractControl {
    return this.otherDetailsForm.get('account_holder_name');
  }
  get account_number(): AbstractControl {
    return this.otherDetailsForm.get('account_number');
  }
  get bsb(): AbstractControl {
    return this.otherDetailsForm.get('bsb');
  }
  get businessPhoneNumber(): AbstractControl {
    return this.contactInformationForm.get('businessPhoneNumber');
  }
  get altEmail(): AbstractControl {
    return this.contactInformationForm.get('altEmail');
  }
  get altPhoneNo(): AbstractControl {
    return this.contactInformationForm.get('altPhoneNo');
  }
  get businessEmail(): AbstractControl {
    return this.contactInformationForm.get('businessEmail');
  }
  // get lName(): AbstractControl {
  //   return this.userForm.get('lName');
  // }
  // // get profileImage(): AbstractControl {
  // //   return this.userForm.get('profileImage');
  // // }
  // get phone(): AbstractControl {
  //   return this.userForm.get('phone');
  // }
  // get email(): AbstractControl {
  //   return this.userForm.get('email');
  // }
  // get password(): AbstractControl {
  //   return this.userForm.get('password');
  // }
  // get confirmPassword(): AbstractControl {
  //   return this.userForm.get('confirmPassword');
  // }
  // get altEmail(): AbstractControl {
  //   return this.userForm.get('altEmail');
  // }
  // get altPhone(): AbstractControl {
  //   return this.userForm.get('altPhone');
  // }
  // get addLine2(): AbstractControl {
  //   return this.userForm.get('addLine2');
  // }
  // get addLine1(): AbstractControl {
  //   return this.userForm.get('addLine1');
  // }
  // get landmark(): AbstractControl {
  //   return this.userForm.get('landmark');
  // }
  // get city(): AbstractControl {
  //   return this.userForm.get('city');
  // }
  // get state(): AbstractControl {
  //   return this.userForm.get('state');
  // }
  // get country(): AbstractControl {
  //   return this.userForm.get('country');
  // }
  // get zipCode(): AbstractControl {
  //   return this.userForm.get('zipCode');
  // }
  // get drivingLicense(): AbstractControl {
  //   return this.userForm.get('drivingLicense');
  // }
  // get regNumber(): AbstractControl {
  //   return this.userForm.get('regNumber');
  // }
  // get accountName(): AbstractControl {
  //   return this.userForm.get('accountName');
  // }
  // get bankName(): AbstractControl {
  //   return this.userForm.get('bankName');
  // }
  // get accountNumber(): AbstractControl {
  //   return this.userForm.get('accountNumber');
  // }
  // get professionType(): AbstractControl {
  //   return this.userForm.get('professionType');
  // }
  // get bsb(): AbstractControl {
  //   return this.userForm.get('bsb');
  // }
  checkBank() {
    this.userDisplay.second_hand = !this.userDisplay.second_hand
  }
  changePhone() {
    this.spinner.show()
    console.log(this.signUpDetailsForm.value)
    this.phoneObj.email = this.token.email
    this.phoneObj.type = this.token.type
    console.log(this.phoneObj)
    this.updatePhone.phone = this.signUpDetailsForm.value.phone
    console.log(this.updatePhone.phone)
    this.profileService.checkData(this.phoneObj).then(data => {
      console.log(data)
      this.statusMsg = data
      if (this.statusMsg.status == 'success') {
        this.spinner.hide()
        this._dialog.open(VerifyOtpComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: { userData: this.phoneObj, updatedData: this.updatePhone, id: this.token.id }
        })
      } else {
        this.spinner.hide()
        this.toast.openSnackBar(
          'You Failed'
        );
      }
    })
  }
  changeContact() {
    this.spinner.show()
    console.log(this.signUpDetailsForm.value)
    this.phoneObj.email = this.token.email
    this.phoneObj.type = this.token.type
    console.log(this.phoneObj)
    // altEmail:this.userDisplay.alt_email,
    // altPhoneNo:this.userDisplay.alt_phone,
    this.contactProf.alt_email = this.contactInformationForm.value.altEmail
    this.contactProf.alt_phone = this.contactInformationForm.value.altPhoneNo
    this.contactSupp.alt_email = this.contactInformationForm.value.altEmail
    this.contactSupp.alt_phone = this.contactInformationForm.value.altPhoneNo
    this.contactSupp.business_email = this.contactInformationForm.value.businessPhoneNumber
    this.contactSupp.business_phone = this.contactInformationForm.value.businessEmail

    this.contactSupp.secondary_name = this.contactInformationForm.value.contactName
    this.contactSupp.secondary_phone = this.contactInformationForm.value.phoneNoTwo
    this.contactSupp.secondary_email = this.contactInformationForm.value.emailTwo
    //this.updatePhone.phone = this.signUpDetailsForm.value.phone

    if (this.emailrequire == true) {
      this.profileService.checkData(this.phoneObj).then(data => {
        console.log(data)
        this.statusMsg = data
        if (this.statusMsg.status == 'success') {
          this.spinner.hide()
          if (this.token.type == "PROFESSIONAL") {
            this._dialog.open(VerifyOtpComponent, {
              width: '30%',
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: { userData: this.phoneObj, updatedData: this.contactProf, id: this.token.id }
            })
          } else {
            this._dialog.open(VerifyOtpComponent, {
              width: '30%',
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: { userData: this.phoneObj, updatedData: this.contactSupp, id: this.token.id }
            })
          }
        } else {
          this.spinner.hide()
          this.toast.openSnackBar(
            'You Failed'
          );
        }
      })
    } else {
      console.log('working');
      this.spinner.hide()
      if (this.token.type == "PROFESSIONAL") {

        this.profileService.updateProf(this.token.id, this.contactProf).then(data => {
          console.log(data)

          this.toast.openSnackBar(
            'Your Data Updated Successfully'
          );
        })

      }

      if (this.token.type == "SUPPLIER") {
        console.log(this.token.id)
        console.log(this.contactSupp)
        this.profileService.updateSupplier(this.token.id, this.contactSupp).then(data => {
          console.log(data)
          this.toast.openSnackBar(
            'Your Data Updated Successfully'
          );
        })

      }

      if (this.token.type == "PRACTICE") {

        this.profileService.updatePractice(this.token.id, this.contactSupp).then(data => {
          console.log(data)
          this.toast.openSnackBar(
            'Your Data Updated Successfully'
          );
        })

      }

    }
  }
  changeBank() {
    this.spinner.show()
    console.log(this.signUpDetailsForm.value)
    this.phoneObj.email = this.token.email
    this.phoneObj.type = this.token.type
    console.log(this.phoneObj)
    this.bankDetails.bank_details.bank_name = this.otherDetailsForm.value.bank_name
    this.bankDetails.bank_details.account_holder_name = this.otherDetailsForm.value.account_holder_name
    this.bankDetails.bank_details.account_number = this.otherDetailsForm.value.account_number
    this.bankDetails.bank_details.bsb = this.otherDetailsForm.value.bsb
    //this.bankDetails.bank_details.bsb = this.otherDetailsForm.value.sellSecondHandSupplies
    this.bankDetails.second_hand = this.otherDetailsForm.value.sellSecondHandSupplies
    //this.updatePhone.phone = this.signUpDetailsForm.value.phone
    this.profileService.checkData(this.phoneObj).then(data => {
      console.log(data)
      this.statusMsg = data
      if (this.statusMsg.status == 'success') {
        this.spinner.hide()
        this._dialog.open(VerifyOtpComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: { userData: this.phoneObj, updatedData: this.bankDetails, id: this.token.id }
        })
      }
      else {
        this.spinner.hide()
        this.toast.openSnackBar(
          'You Failed'
        );
      }
    })
  }
  openField() {
    this.phoneBlock = false
    this.phone.enable();
    this.emailrequire = true
  }
  bankOne() {
    this.bankOneBlock = false
    this.bank_name.enable();
    this.emailrequire = true
  }
  bankTwo() {
    this.bankOneBlock = false
    this.account_holder_name.enable();
    this.emailrequire = true
  }
  bankThree() {
    this.bankOneBlock = false
    this.account_number.enable();
    this.emailrequire = true
  }
  bankFour() {
    this.bankOneBlock = false
    this.bsb.enable();
    this.emailrequire = true
  }
  altPhone() {
    this.conBlock = false
    this.altPhoneNo.enable();
    this.emailrequire = true
  }
  buzzEmail() {
    this.conBlock = false
    this.businessEmail.enable()
    this.emailrequire = true
  }
  altMail() {
    this.conBlock = false
    this.altEmail.enable()
    this.emailrequire = true
  }
  buzzPhone() {
    this.conBlock = false
    this.businessPhoneNumber.enable()
    this.emailrequire = true
  }
  onSelectFileDp(event) {
    this.emailrequire = true
    this.spinner.show()
    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.spinner.hide()
      this.userPhoto = response
      if (this.userDisplay.type == "PROFESSIONAL") {
        this.profImage.profile_image = this.userPhoto
        this.profileService.updateUserImageProf(this.userDisplay.id, this.profImage)
      }
      if (this.userDisplay.type == "SUPPLIER") {
        this.suppImage.logo = this.userPhoto
        const status = this.profileService.updateUserImageSupplier(this.userDisplay.id, this.suppImage)
        if (status) {
          this.userDisplay.logo = this.userPhoto
        }
        // this.userDisplay.logo = this.userPhoto
      }
      if (this.userDisplay.type == "PRACTICE") {
        this.pracImage.logo = this.userPhoto
        this.profileService.updateUserImagePractice(this.userDisplay.id, this.pracImage)
      }
      // this.subscriberDetailForm.patchValue({
      //   userDp : response.url
      // })
    });
  }
}
